export default {
  // ShareModal - 共有モーダル
  shareModalTitle: '{{petName}}のケア情報を共有',
  shareModalSubtitle: '共有する情報タイプを選択し、安全なリンクを生成します',
  close: '閉じる',
  
  // ShareModal - 共有を有効化
  enableSharingFeature: '共有機能を有効にする',
  sharingPrivacyNotice: '「{{petName}}」の共有機能を有効にしようとしています。これにより、介護者とペット情報を共有できる安全な共有リンクが生成されます。',
  sharingFeatures: '共有機能の特徴',
  uniqueSecureLink: 'ユニークで安全なリンク',
  selectableInfoTypes: '選択可能な情報タイプ',
  disableAnytime: 'いつでも無効化可能',
  noPersonalInfoLeak: '個人情報の漏洩なし',
  notNow: '今はしない',
  enabling: '有効化中...',
  enableSharing: '共有を有効にする',
  
  // ShareModal - エラーメッセージ
  shareEnableError: '共有機能の有効化に失敗しました',
  shareDisableError: '共有機能の無効化に失敗しました',
  
  // ShareModal - タブ
  shareSelectInfo: '情報を選択',
  shareVia: '共有方法',
  
  // ShareModal - 情報を選択
  selectedItems: '{{count}}項目選択済み',
  shareSelectAll: 'すべて選択',
  shareDeselectAll: 'すべて解除',
  
  // ShareModal - 共有オプション
  sharePhoto: 'ペット写真',
  sharePhotoDesc: 'ペットの写真を共有',
  shareBasicInfo: '基本情報',
  shareBasicInfoDesc: '名前、品種、年齢、性別などを含む',
  shareDietaryInfo: '食事情報',
  shareDietaryInfoDesc: '給餌スケジュール、好み、制限を含む',
  shareBehaviorInfo: '行動情報',
  shareBehaviorInfoDesc: '気質、好き嫌い、運動ニーズなどを含む',
  shareHealthInfo: '健康情報',
  shareHealthInfoDesc: '投薬スケジュール、ワクチン、アレルギーを含む',
  shareEmergencyContact: '緊急連絡先',
  shareEmergencyContactDesc: '獣医の連絡先と保険情報を含む',
  shareSpecialNotes: '特記事項',
  shareSpecialNotesDesc: 'その他の重要なケアノート',
  
  // ShareModal - プレビュー
  preview: 'プレビュー',
  previewDescription: '共有前に共有ページの外観をプレビュー',
  
  // ShareModal - 共有方法
  chooseShareMethod: '共有方法を選択',
  shareViaEmail: 'メール経由',
  shareViaEmailDesc: 'メールクライアントで共有',
  shareViaWhatsApp: 'WhatsApp経由',
  shareViaWhatsAppDesc: 'WhatsAppで共有',
  shareViaLine: 'LINE経由',
  shareViaLineDesc: 'LINEで共有',
  
  // ShareModal - 共有リンク
  shareableLink: '共有可能なリンク',
  copyLink: 'リンクをコピー',
  copied: 'コピー済み',
  generating: '生成中...',
  
  // ShareModal - 共有メッセージテンプレート
  emailSubject: '{{petName}}のケア情報',
  emailBody: 'こんにちは！\n\n{{petName}}のケア情報を共有したいと思います。以下のリンクをクリックしてご覧ください：\n\n{{shareUrl}}\n\nありがとうございます！',
  whatsappMessage: 'こんにちは！{{petName}}のケア情報を共有したいと思います：{{shareUrl}}',
  lineMessage: '{{petName}}のケア情報',
  
  // ShareModal - セキュリティヒント
  securityReminder: 'セキュリティリマインダー',
  shareOnlyWithTrusted: '信頼できる介護者とのみこのリンクを共有してください。共有はいつでも無効化できます。',
  
  // ShareModal - 共有を無効化
  disableSharing: '共有を無効にする',
  processing: '処理中...',
  confirmDisable: '無効化を確認',
  
  // DisableShareConfirmModal - 共有無効化確認
  disableSharingTitle: '共有機能を無効にする',
  disableSharingMessage: 'このペットの共有機能を無効にしてもよろしいですか？',
  shareLinksInvalid: 'すべての既存の共有リンクが即座に無効になります',
  viewersLoseAccess: 'リンクを持っている人はデータを閲覧できなくなります',
  cancel: 'キャンセル',
  
  // DeleteConfirmModal - 削除確認
  confirmDelete: '削除を確認',
  cannotUndo: 'この操作は元に戻せません',
  deletePetData: 'ペットデータを削除',
  confirmDeletePetMessage: '「{{petName}}」のすべてのデータを削除してもよろしいですか？',
  willLoseAfterDelete: '削除後、以下を失います：',
  allBasicData: 'すべての基本データと写真',
  healthRecordsAndVaccines: '健康記録とワクチン情報',
  careInstructionsAndNotes: 'ケア指示とノート',
  uploadedPhotos: 'アップロードした写真',
  shareLinksWillExpire: 'すべての共有リンクが期限切れになります',
  deleting: '削除中...',
  deleteWarningMessage: '慎重に操作してください。削除されたデータは復元できません',
  unnamedPet: '名前のないペット',
  
  // LogoutConfirmModal - ログアウト確認
  confirmLogout: 'ログアウトを確認',
  logoutConfirmMessage: 'ログアウトしてもよろしいですか？ペットデータにアクセスするには再度ログインする必要があります。',
  logout: 'ログアウト',
  loggingOut: 'ログアウト中...',
};